<script setup lang="ts">
import { computed } from 'vue';

import ActiveVariantCheckmark from '@/components/GalleryOptions/ActiveVariantCheckmark.vue';
import ColornamePopover from '@/components/GalleryOptions/ColornamePopover.vue';
import Image from '@/shared/components/UI/Image.vue';
import StockIndicator from '@/shared/components/UI/StockIndicator.vue';
import { Variant } from '@/shared/composables/patternProducts/patternProducts.types';

const props = defineProps<{
  variant: Variant;
  active: Variant | null;
}>();
const imgSrc = (src: string, w: number, h: number) => {
  const url = new URL(src);
  url.searchParams.set('width', w.toString());
  url.searchParams.set('height', h.toString());
  url.searchParams.set('q', '80');
  return url.toString();
};
defineEmits(['click']);
const colorNumber = computed(() => {
  return props.variant.colorCode?.value || '';
});
</script>

<template>
  <div
    class="group relative z-1 -ml-px -mt-px grid aspect-square cursor-pointer select-none place-items-center text-center hover:z-20"
    :class="active?.id == variant.id ? 'z-10' : 'z-1'"
    @click="$emit('click', variant)"
  >
    <div
      class="pointer-events-none absolute left-0 top-0 size-full border transition-colors duration-300 group-hover:border-primary"
      :class="[
        active?.id == variant.id ? 'z-20 border-primary' : 'z-10',
        {
          'before:absolute before:left-0 before:top-1/2 before:z-10 before:block before:h-1 before:w-full before:origin-center before:rotate-45 before:bg-white after:absolute after:left-0 after:top-1/2 after:z-10 after:block after:h-1 after:w-full after:origin-center after:-rotate-45 after:bg-white':
            variant.quantityAvailable <= 0
        }
      ]"
    >
      <ColornamePopover v-if="variant.title">{{
        variant.title
      }}</ColornamePopover>

      <Image
        v-if="variant.image?.url"
        :src="imgSrc(variant.image.url, 200, 200)"
        :lazy-load="true"
        loader="fade"
        :width="200"
        :height="200"
        :alt="variant.title"
        class=""
        :class="variant.quantityAvailable <= 0 ? 'opacity-40' : ''"
      />
      <div
        v-if="colorNumber"
        class="absolute bottom-px left-px rounded bg-white/90 px-1 py-px text-xs text-gray-500"
      >
        {{ colorNumber }}
      </div>
      <ActiveVariantCheckmark v-if="active?.id == variant.id" />

      <StockIndicator
        class="absolute left-0 top-0 p-1 text-xs"
        :in-stock="variant.quantityAvailable"
      />
    </div>
  </div>
</template>
